import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ROUTE_URLS } from 'constants/index';
import { useTranslation } from 'react-i18next';

const Footer = () => {
	const { t } = useTranslation();
	const { DEV_PORTAL } = ROUTE_URLS;
	const _now = new Date(Date.now());
	let location = useLocation();
	if (location.pathname.match('/app-creator')) return '';

	return (
		<section className="dhlsmuvcdc dhlsmuvcdc-xl">
			<div className="ykiyguxiww ykiyguxiww-xl">
				<div className="ncwkpamvyl ncwkpamvyl-xl">
					<nav className="menu menu-default">
						<div className="menu menu-horizontal">
							<ul className="nav">
								<li className="nav-item">
									<a href="https://www.paycor.com/" className="nav-link">
										{t('footer_paycor.com')}
									</a>
								</li>
								<li className="nav-item">
									<NavLink to="/" className="nav-link">
										{t('footer_Home')}
									</NavLink>
								</li>
								<li className="nav-item">
									<NavLink to={DEV_PORTAL.API_EXPLORE} className="nav-link">
										{t('footer_apis')}
									</NavLink>
								</li>
								<li className="nav-item">
									<NavLink to={DEV_PORTAL.GUIDES} className="nav-link">
										{t('footer_guides')}
									</NavLink>
								</li>
								<li className="nav-item">
									<NavLink to={DEV_PORTAL.SUPPORT} className="nav-link nav-link-active">
										{t('footer_support')}
									</NavLink>
								</li>
								<li className="nav-item">
									<a href="https://marketplace.paycor.com/" className="nav-link">
										{t('footer_marketplace')}
									</a>
								</li>
								<li className="nav-item">
									<a href="http://partnerportal.paycor.com/" className="nav-link">
										{t('footer_Partner_with_us')}
									</a>
								</li>
								<li className="nav-item">
									<NavLink to={DEV_PORTAL.TERMS_OF_USE} className="nav-link">
										{t('footer_Termsofuse')}
									</NavLink>
								</li>
							</ul>
						</div>
					</nav>
					<div className="block ProseMirror">
						<p className="text text-xl-align-center">
							&copy; {_now.getFullYear()} {t('footer_paycor_inc')} | <a href="https://www.paycor.com/privacy-policy">{t('footer_privacy_policy')} </a>| 1-800-501-9462
						</p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Footer;
